import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class WinningScientificCompetitionParent extends List {
  constructor(obj) {
    super(WinningScientificCompetition, obj)
  }
}

export class WinningScientificCompetition {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.reward = obj?.reward || null
    this.founder = obj?.founder || null
    this.theme = obj?.theme || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      reward: this.reward,
      founder: this.founder,
      theme: this.theme
    }
  }
}
